import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";

import { IRoleRequestsResponse, ITableRequestData } from "../../types/common";
import { RoleState } from "../../types/features/roleSlice";
import { createRoleService, deleteRoleService, getRoleByIdService, getRoleTableService, updateRoleService } from "../../api/roleApi";


export const createRoleData = createAsyncThunk<IRoleRequestsResponse, { data: any }>(
    "role/createRoleData", async ({ data }) => {
        const response = await createRoleService(data);
        return response.data;
    });

export const getRoleData = createAsyncThunk<IRoleRequestsResponse, ITableRequestData>(
    "role/getRoleData", async ({ limit, page, status, order_type }) => {
        const response = await getRoleTableService({
            limit,
            page,
            status,
            order_type
        });
        return response.data;
    });

export const getRoleByIdData = createAsyncThunk<IRoleRequestsResponse, { id: string }>(
    "role/getRoleByIdData", async ({ id }) => {
        const response = await getRoleByIdService({ id });
        return response.data;
    });

export const updateRoleData = createAsyncThunk<IRoleRequestsResponse, { id: string; data: any }>(
    "role/updateRoleData", async ({ id, data }) => {
        const response = await updateRoleService({ id, data });
        return response.data;
    });

export const deleteRoleData = createAsyncThunk<IRoleRequestsResponse, { id: string }>(
    "role/deleteRoleData", async ({ id }) => {
        const response = await deleteRoleService({ id });
        return response.data;
    });

const RoleSlice = createSlice({
    name: "Role",
    initialState: {
        roleLoader: false,
        status: false,
        msg: "",
        data: null,
        detail: null,
        pagination: null,
    } as RoleState,
    reducers: {
        // filterByOrderType: (state, action: PayloadAction<string>) => {
        //   const orderType = action.payload;
        //   // // console.log(state.data, "state.data");

        //   if (orderType === "expire") {
        //     state.data =
        //       state.data?.filter((record: any) => record.ReturnCode === "R08") ||
        //       null;
        //   } else if (orderType === "return_order") {
        //     state.data =
        //       state.data?.filter((record: any) => record.ReturnCode !== "R08") ||
        //       null;
        //   }
        // },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getRoleData.pending, (state) => {
                state.roleLoader = true;
            })
            .addCase(
                getRoleData.fulfilled,
                (state, action: PayloadAction<IRoleRequestsResponse>) => {
                    // console.log(action.payload, 'action.payload.data');
                    state.data = action.payload.data;
                    state.pagination = action.payload.pagination || null;
                    state.msg = action.payload.message;
                    state.status = true;
                    state.roleLoader = false;
                }
            )
            .addCase(getRoleData.rejected, (state, action) => {
                state.roleLoader = false;
                state.status = false;
                state.msg = action.error.message;
            })

            .addCase(createRoleData.pending, (state) => {
                state.roleLoader = true;
            })
            .addCase(
                createRoleData.fulfilled,
                (state, action: PayloadAction<IRoleRequestsResponse>) => {
                    // // // console.log(action.payload, 'action.payload.data');

                    // state.data = action.payload.order_data;
                    state.msg = action.payload.message;
                    state.status = true;
                    state.roleLoader = false;
                }
            )
            .addCase(createRoleData.rejected, (state, action) => {
                state.roleLoader = false;
                state.status = false;
                state.msg = action.error.message;
            })
            .addCase(getRoleByIdData.pending, (state) => {
                state.roleLoader = true;
            })
            .addCase(
                getRoleByIdData.fulfilled,
                (state, action: PayloadAction<IRoleRequestsResponse>) => {
                    state.detail = action.payload.data;
                    state.msg = action.payload.message;
                    state.status = true;
                    state.roleLoader = false;
                }
            )
            .addCase(getRoleByIdData.rejected, (state, action) => {
                state.roleLoader = false;
                state.status = false;
                state.msg = action.error.message;
            })
            .addCase(updateRoleData.pending, (state) => {
                state.roleLoader = true;
            })
            .addCase(updateRoleData.fulfilled, (state, action: PayloadAction<IRoleRequestsResponse>) => {
                state.msg = action.payload.message;
                state.status = true;
                state.roleLoader = false;
            }
            )
            .addCase(updateRoleData.rejected, (state, action) => {
                state.roleLoader = false;
                state.status = false;
                state.msg = action.error.message;
            })
            .addCase(deleteRoleData.pending, (state) => {
                state.roleLoader = true;
            })
            .addCase(deleteRoleData.fulfilled, (state, action: PayloadAction<IRoleRequestsResponse>) => {                    // state.detail = action.payload.data;
                state.msg = action.payload.message;
                state.status = true;
                state.roleLoader = false;
            })
            .addCase(deleteRoleData.rejected, (state, action) => {
                state.roleLoader = false;
                state.status = false;
                state.msg = action.error.message;
            });

    },
});

// export const { filterByOrderType } = RoleSlice.actions;  
export default RoleSlice.reducer;
